import { useState } from "react";
import "./Register.css";
import { useNavigate } from "react-router-dom";

function Register() {
  const [data, setData] = useState({
    name: "",
    mobile: "",
    address: "",
    email: "",
    password: ""
  });

  const navigate = useNavigate();

  const handleRegister = async (e) => {
  e.preventDefault();

  try {
    const res = await fetch("https://citrine-backend-0hws.onrender.com/api/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    console.log("STATUS:", res.status);

    const result = await res.json();
    console.log("Response:", result);

    if (res.ok) {
      alert("User Registered");
      navigate("/login");
    } else {
      alert(result.message || "Registration failed");
    }

  } catch (err) {
    console.error("ERROR:", err);
    alert("Server error");
  }
};

  return (
    <div className="register-container">
      <form className="register-card" onSubmit={handleRegister}>
        <div className="register-title">Register</div>

        <input
          className="register-input"
          placeholder="Name"
          onChange={(e)=>setData({...data,name:e.target.value})}
        />

        <input
          className="register-input"
          placeholder="Mobile"
          onChange={(e)=>setData({...data,mobile:e.target.value})}
        />

        <input
          className="register-input"
          placeholder="Address"
          onChange={(e)=>setData({...data,address:e.target.value})}
        />

        <input
          className="register-input"
          placeholder="Email"
          onChange={(e)=>setData({...data,email:e.target.value})}
        />

        <input
          className="register-input"
          type="password"
          placeholder="Password"
          onChange={(e)=>setData({...data,password:e.target.value})}
        />

        <button className="register-button" type="submit">
          Register
        </button>

        <div className="register-footer">
          Already have an account?{" "}
          <span onClick={()=>navigate("/login")}>
            Login
          </span>
        </div>
      </form>
    </div>
  );
}

export default Register;